import { useTranslation } from 'react-i18next';
import { Segmented } from '@/components/ui';
import { useTheme, type ThemePreference } from '@/lib/theme';

/** 外观：跟随系统 / 浅色 / 深色（CR-081）。App 的「我的」页和网页端左下角账号区各放一个 */
export function ThemeSelect({ hideLabel, block }: { hideLabel?: boolean; block?: boolean }) {
  const { t } = useTranslation();
  const [theme, setTheme] = useTheme();
  return (
    <Segmented<ThemePreference>
      label={t('settings.theme')}
      hideLabel={hideLabel}
      block={block}
      value={theme}
      onChange={setTheme}
      options={[
        { value: 'system', label: t('settings.themeSystem') },
        { value: 'light', label: t('settings.themeLight') },
        { value: 'dark', label: t('settings.themeDark') },
      ]}
    />
  );
}
